import Theme from '../theme';

/**
 * Create the action
 */

const { thunk, request, success, error } = Theme.destroy((id, fetch) => {
    return fetch.delete(`/themes/${id}`);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };